/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/moon_medium'
export default icon
